"use client";

import { Button } from "@/components/buttons/Button";
import { LinkButton } from "@/components/links/LinkButton";
import { usePricingModal } from "@/lib/zustand/usePricingModal";
import { UserNoDates } from "@/types/types";
import { isFreeUser } from "@/utils/subscriptionLevels/isFreeUser";
import { isHighestPlan } from "@/utils/subscriptionLevels/isHighestPlan";

export function UpgradeLink({ user }: { user: UserNoDates }) {
  const setPricingModalOpen = usePricingModal((state) => state.setOpen);

  const clickHandler = () => {
    setPricingModalOpen();
  };

  const highestPlan = isHighestPlan(user.stripeSubscriptionId);

  if (highestPlan) {
    return null;
  }

  const freeUser = isFreeUser(user.stripeSubscriptionId);

  if (freeUser) {
    return <Button onClick={clickHandler}>Upgrade</Button>;
  }

  return <LinkButton onClick={clickHandler}>Upgrade →</LinkButton>;
}
